import React from "react";

import { Animation, Popup, Position } from "devextreme-react/popup";
import { ProgressBar } from "devextreme-react/progress-bar";

import { useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";

const elementAttr = {
  class: "progress-bar-status",
};

export const BootPopup = () => {
  const lock = useFxSelector(schema.lock.select);
  const isBooting = (lock || "").startsWith("$:bootup");
  const showingPopup = useFxSelector(schema.loaderPopup.select);
  const bootProgress_ = useFxSelector(schema.loaderBootProgress.select);
  const bootAction = useFxSelector(schema.loaderBootText.select);
  const processed = (bootProgress_ || 0).toFixed(2);
  const loaderText = useFxSelector(schema.loaderText.select);
  return (
    <Popup
      visible={isBooting && showingPopup}
      dragEnabled={false}
      showTitle={false}
      width={510}
      height={150}
      hideOnOutsideClick={false}
      shading={false}
      showCloseButton={true}
    >
      <div style={{ padding: "10px" }}>
        <div>{bootAction}</div>
        <ProgressBar
          id="progress-bar-status"
          className={processed === 100 ? "complete" : ""}
          width="90%"
          min={0}
          max={100}
          elementAttr={elementAttr}
          value={processed}
        />
        <div style={{ marginTop: "10px" }}>{loaderText}</div>
      </div>
      <Position my="right bottom" at="right bottom" of={window} />
      <Animation
        hide={{
          type: "fade",
          duration: 700,
          from: { opacity: 1 },
          to: { opacity: 0 },
        }}
        show={{
          type: "fade",
          duration: 700,
          from: { opacity: 0 },
          to: { opacity: 1 },
        }}
      />
    </Popup>
  );
};
